import JsPDF from 'jspdf'
import fieldType from '@/enums/fieldType'
import 'jspdf-autotable'
import '../fonts/OpenSans'
import Page from './Page'
import Vue from 'vue'

const DEFAULT_FORMAT = {
  width: 210,
  height: 297,
  format: 'a4',
  orientation: 'p',
  unit: 'mm'
}
const DEFAULT_TEXT_FORMAT = {
  font: 'OpenSans',
  fontSize: 9,
  fontType: 'normal'
}

function prepareTableData (field, scores) {
  let subFields = field['sub-fields']
  let body = scores.map(row => {
    let score = []
    for (var key in row) {
      let value = Vue.filter('field')(row[key].value, subFields[key - 1].type)
      score.push(value)
    }
    return score
  })
  let columns = []
  subFields.forEach(subField => {
    columns.push(subField.name)
  })
  let table = { head: [columns], body }
  return table
}

function createPageFormat (print) {
  if (print === null || print === undefined || print === '') {
    return DEFAULT_FORMAT
  }
  let size = Page.getSize(print.format, print.orientation)
  return {
    width: size.width,
    height: size.height,
    format: print.format.toLowerCase(),
    orientation: (print.orientation === 'v') ? 'p' : 'l',
    unit: 'mm'
  }
}

export default class Pdf {
  constructor (schema) {
    this.pageFormat = createPageFormat(schema.print)
    this.GRID_X = (schema.print.orientation === 'h') ? 40 : 20
    this.GRID_Y = (schema.print.orientation === 'h') ? 32 : 46
    this.jsPdf = new JsPDF(this.pageFormat)
    this.jsPdf.setFont(DEFAULT_TEXT_FORMAT.font)
    this.jsPdf.setFontType(DEFAULT_TEXT_FORMAT.fontType)
    this.jsPdf.setFontSize(DEFAULT_TEXT_FORMAT.fontSize)
    this.jsPdf.deletePage(1)
    this.schema = schema
  }
  save () {
    this.jsPdf.save(this.schema.name)
  }
  getGridSize () {
    return {
      x: (this.pageFormat.width - this.schema.print.margin_left - this.schema.print.margin_right) / this.GRID_X,
      y: (this.pageFormat.height - this.schema.print.margin_top - this.schema.print.margin_bottom) / this.GRID_Y
    }
  }
  loadMultipleRecords (records) {
    records.forEach(record => this.loadRecord(record))
  }
  loadRecord (record) {
    this.jsPdf.addPage(this.pageFormat)
    this.schema.fields.forEach(field => {
      if (field.type === fieldType.TABLE) {
        this.addTable({
          table: prepareTableData(field, record.results[field.order].value),
          location: field.location
        })
      } else {
        this.addText({
          name: field.name,
          value: record.results[field.order].value,
          location: field.location,
          type: field.type
        })
      }
    })
    this.schema.print.constant_fields.forEach(constantField => {
      if (constantField.type === 'image') {
        // this.addImage({
        //   url: constantField.value,
        //   location: constantField.location
        // })
      } else {
        this.addText({
          name: '',
          value: constantField.value,
          location: constantField.location
        })
      }
    })
    // this.schema.print.generated_fields.forEach(generatedField => {
    //   this.addText({
    //     name: '',
    //     value: generatedField.value,
    //     location: generatedField.location
    //   })
    // })
  }
  addText (field) {
    let grid = this.getGridSize()
    let position = [ this.getLeftEdge(field.location.latitude), this.getUpperEdge(field.location.longitude) ]
    let text = (field.name) ? field.name + ' - ' + Vue.filter('field')(field.value, field.type) : field.value
    let formated = this.jsPdf.splitTextToSize(text, field.location.width * grid.x)
    this.jsPdf.text(formated, ...position)
  }
  addTable (field) {
    let grid = this.getGridSize()
    let table = field.table
    table.startY = this.getUpperEdge(field.location.longitude)
    table.margin = {
      left: this.getLeftEdge(field.location.latitude),
      right: (this.GRID_X - field.location.latitude - field.location.width) * grid.x + this.schema.print.margin_right
    }
    table.theme = 'grid'
    table.styles = { font: DEFAULT_TEXT_FORMAT.font }
    table.headStyles = { font: DEFAULT_TEXT_FORMAT.font, fontStyle: DEFAULT_TEXT_FORMAT.fontType, fillColor: 80 }
    this.jsPdf.autoTable(table)
  }
  addImage (field) {
    let size = this.getGridSize()
    let position = [
      this.getLeftEdge(field.location.latitude),
      this.getUpperEdge(field.location.longitude),
      field.width * size.x,
      field.height * size.y
    ]
    let image = new Image()
    image.src = field.url
    this.jsPdf.addImage(image, 'JPEG', ...position)
  }
  getLeftEdge (latitude) {
    return latitude * this.getGridSize().x + this.schema.print.margin_left
  }
  getUpperEdge (longitude) {
    return longitude * this.getGridSize().y + this.schema.print.margin_top
  }
}
